// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"447ccfd8","859":"1e65a7fd"}[chunkId] + ".chunk.css";
};